<template>
  <section class="flex level-1" :class="{mobile:!mobile}">   

    <!-- //TITLE MOBILE -->
      <div class="mobile"  :class="{isMobile:isMobile}" v-if="mobile">
        <div class="link">
          <button class="bt btn-back" @click="goBack()">
            <font-awesome-icon :icon="['far', 'angle-left']"/>
          </button>
          <h2>Jeu concours</h2>
        </div>
        <div class="sep"></div>
      </div>
    <!-- //TITLE MOBILE -->

    <div  class="block__challengesAccueil  content__challengesAccueil"  style="height: 100vh">


      <!-- BREADCRUMB -->
      <b-breadcrumb class="desktop">
          <b-breadcrumb-item @click.prevent="goBack" >Challenges</b-breadcrumb-item>
          <b-breadcrumb-item active>Challenges en cours</b-breadcrumb-item>
      </b-breadcrumb>
      <!-- BREADCRUMB -->

      <div class="sep desktop"></div>


      <!-- //TITLE DESKTOP -->
      <div class="header desktop" >
        <h1>{{general.challengesAll}}</h1>
      </div>
      <!-- //TITLE DESKTOP -->

      <b-row v-if="lastChallengesInprogress.length">
        <b-col sm='12' md='6' class="mb-4" v-for="(item,index) in lastChallengesInprogress" :key="index">
          <cardChallengesPicture
              :subtitle = "'Jeu concours'"
              :title = item.title
              :ranking = "'Classement'"
              :rankingNumber = item.totalRank
              :rankingPrevious = item.previousRank
              :rank = item.rank
              :score = "'Score'"
              :scoreNumber = item.score
              :target = getConcoursSatus(item)
              :img = item.challengeMedia
              :isLoad.sync = isLoading
              link =  "accueil"
          />
<!--            <cardChallengesDate-->
<!--            :id = item.id-->
<!--            :title = item.criteria-->
<!--            :subtitle = item.criteria-->
<!--            :startDate =  item.startDate-->
<!--            :endDate = item.endDate-->
<!--            :objectiveNumber = item.objective-->
<!--            :inprogress = item.score-->
<!--            :state = item.target-->
<!--            :isLoad.sync = isLoading-->
<!--            />-->
        </b-col>
      </b-row>
      <b-row  v-else>
         <b-col sm='12' md='6' class="mb-4">
           <p>Aucun challenges en cours</p>
         </b-col>        
      </b-row>
    </div>

  </section>
</template>


<script>
import { mapGetters } from 'vuex'
import ChallengesMixin from '../challenges/ChallengesMixin'
import ApiService from '../../../../services/ApiService'
import ApiAuthenticationService from '../../../../services/ApiAuthenticationService'
import cardChallengesPicture from "@/components/module/card/CardChallengesPicture.vue";
import moment from 'moment'
moment.locale('fr');

export default {
  name:"challengesConcours",
    components:{
      cardChallengesPicture,
    }, 
    mixins: [
      ChallengesMixin      
    ], 
    computed: {
      ...mapGetters([
        'getGeneral',
          'getIsMobile'
      ])
    },
    props:{
      mobile:{
        type:Boolean,
        default:true
      }
    },
    data () {
      return {
        general:"",
        isLoading: true,
        lastChallengesInprogress: [{},{}],
      }
    },

    created (){
      this.general = this.getGeneral;
      this.isMobile = this.getIsMobile;
      this.isMobile ? this.$store.dispatch('showHeader',false) : ''; 
      this.getData().then(()=>{
        this.isLoading = false;
      });
    },
    methods : {   
      async getData(){
        await ApiService.getConcoursApi().getCards(ApiAuthenticationService.getCurrentUser().id, 100, 0,'all').then((data) => {
              if (data.data.length > 0) {
                this.lastChallengesInprogress = [];

                for (let i = 0; i < 20; i++) {
                  if (data.data[i] !== undefined) {
                    let contest = data.data[i];

                    contest.challengeMedia = data.data[i].image ? data.data[i].image.id : '';

                    this.lastChallengesInprogress.push(contest);
                  }
                }
              } else {
                this.lastChallengesInprogress = [];
              }
        },
            () => {
          this.lastChallengesInprogress = null;
            });
      },
      getConcoursSatus(item) {
        if (moment(item.startDate).unix() >= moment().unix()) {
          return 'todo';
        }
        if (moment(item.endDate).unix() >= moment().unix()) {
          return 'in_progress';
        } else {
          return 'done';
        }
      },
      goBack() {
        this.$store.dispatch('goBack');
        this.$router.push({name: "challengesHome"});  
        if (this.isMobile){
          this.$store.dispatch('showHeader',true);
          this.$store.dispatch('showFooter',true);
        }
      },
    },
  watch : {
    getIsMobile(){
      this.isMobile = this.getIsMobile;
    }
  }
  };
</script>
